module.exports = require("vuetify/lib/components/VRadioGroup");